import { defineStore, } from "pinia";

export const useMainTabsStore = defineStore("mainTabs", {
    state: () => {
        return {
            currentTab: 0,
            tabs: {
                "applications": "Applications",
                "usageTime": "Usage Time",
                "personalControls": "Personal Controls",
                "categories": "Categories",
                "groups": "Groups",
                "security": "Security Settings",
            },
            tabs_icons: {
                "security": "mdi-lock",
                "usageTime": "mdi-clock-outline",
                "personalControls": "mdi-clock-time-eight",
            },
            tabIndices: {
                applications: 0,
                usageTime: 1,
                personalControls: 2,
                categories: 3,
                groups: 4,
                security: 5,
            },
        };
    },
});
